/* Generado desde DataTableFrame.razor.css del portal actual (scripts/razor-css-to-module.py): misma cascada que Blazor. */
.bh-table-frame.scope{min-width:0;max-width:100%;overflow:auto;border:0;border-radius:0;box-shadow:none;background:transparent}
